import { ADMIN_TABS } from '../../constants/actions';
import { currentPath } from '../../selectors/router';
import { savePreferences } from '../authentication';
export function setTab(tab) {
    return (dispatch, getState) => {
        const path = currentPath(getState());
        savePreferences('tabs', { [path]: tab })(dispatch, getState);
        dispatch({
            type: ADMIN_TABS.SET,
            tab
        });
    };
}

export function blockTabSwitch() {
    return { type: ADMIN_TABS.DISABLE };
}

export function enableTabSwitch() {
    return { type: ADMIN_TABS.ENABLE };
}
